import { action, computed, observable, makeObservable } from "mobx";
import { MrbBasePreviewViewStore } from "mrb/core";
import { MrbModalParams } from "mrb/common/models";
import { localizationService } from "common/localization";
import { find, filter, includes } from "lodash";
import { DownloadRequest } from "common/models";

class LoadioAlbumTrackListFilter {
    @observable search = "";

    constructor() {
        makeObservable(this);
    }

    @action.bound
    setSearch(search) {
        this.search = search;
    }
}

class LoadioAlbumTrackListViewStore extends MrbBasePreviewViewStore {
    @observable songs = [];
    @observable.ref filter = new LoadioAlbumTrackListFilter();

    @computed get filteredSongs() {
        if (this.filter.search === "") {
            return this.songs;
        }
        return filter(this.songs, (song) => {
            if (
                this.filter.search !== "" &&
                this.filter.search != null &&
                !includes(song.title.toLowerCase(), this.filter.search.toLowerCase())
            ) {
                return false;
            }

            return true;
        });
    }

    @computed get coverImageUrl() {
        if (this.item && this.item.coverImageId) {
            return this.rootStore.coverImageFactory.createLoadioAlbumCoverImageUrl(this.item.coverImageId, 150, 150);
        }

        return null;
    }

    constructor(rootStore, { routeStore }) {
        const albumId = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            id: albumId,
        });
        makeObservable(this);
        this.routeStore = routeStore;

        this.editAlbumTrackModal = new MrbModalParams();

        this.openEditAlbumTrack = this.openEditAlbumTrack.bind(this);
    }

    async onInit() {
        await Promise.all([this.getSongs(this.id), this.initializeResource()]);
    }

    get(id) {
        return this.routeStore.getAlbum(id);
    }

    @action.bound
    async getSongs(albumId) {
        try {
            const embed = "genre";
            const params = { embed: embed };
            const songs = await this.routeStore.getSongs(albumId, params);
            this.setSongs(songs);
        } catch (err) {
            this.rootStore.notificationStore.error(
                localizationService.t("ADMINISTRATION.LOADIO.TRACKS.ERROR.FETCH_TRACKS_GENERIC"),
                err
            );
        }
    }

    @action.bound
    async editAlbumTrackTitle(albumTrackId, title) {
        const data = { title: title };
        try {
            await this.routeStore.editAlbumTrackTitle(albumTrackId, data);
        } catch (err) {
            this.rootStore.notificationStore.error(
                localizationService.t("ADMINISTRATION.LOADIO.ARTIST.PREVIEW.ALBUM.TRACK_LIST.ERROR.GENERIC_MESSAGE"),
                err
            );
        }
        this.editAlbumTrackModal.close();
    }

    openEditAlbumTrack(albumTrack) {
        this.editAlbumTrackModal.open({
            id: albumTrack.id,
            title: albumTrack.title,
            editAlbumTrackTitle: this.editAlbumTrackTitle,
        });
    }

    @action.bound
    setSongs(songs) {
        this.songs = songs;
    }

    updateAlbumTrackTitle(songId, newTitle) {
        const song = find(this.songs, (song) => song.id === songId);
        if (song) {
            song.title = newTitle;
        }
    }

    downloadAlbumTrack = (item) => {
        if (item && item.audioStreamUrl) {
            var downloadRequest = new DownloadRequest(
                item.id,
                item.title,
                item.artworkUrl,
                this.routeStore.createAlbumTrackAudioFileUrl(item.id),
                item.duration,
                item.audioFileSize
            );
            this.routeStore.rootStore.downloadManagerStore.addItemToQueue(downloadRequest);
        } else {
            return null;
        }
    };
}

export default LoadioAlbumTrackListViewStore;
